import { createContext } from "react";
import { AssetManagerConfigurationType, QueryStatus } from "@shared/types";

export interface BrandingContextType {
  isWhitelabel: boolean;
  allowViewOnlyUsersToViewBots: boolean;
  brandingData: AssetManagerConfigurationType | undefined;
  getBrandingDataStatus: QueryStatus<AssetManagerConfigurationType>;
}

export const BrandingContext = createContext<BrandingContextType | undefined>(
  undefined
);
